import React, { useEffect, useMemo, useState } from 'react'

import PropTypes from 'prop-types'
import { useLazyQuery } from '@apollo/client'
import { Button, Col, Row } from 'react-bootstrap'

import styles from './style.module.scss'
import { GET_RANDOM_ARTICLE } from '@graphql/article/article.query'
import CustomLink from '@shared/components/customLink'
import TopPlayerRankings from '@shared/components/topPlayerRankings'
import ArticleGrid from '@shared/components/article/articleGrid'
import NoData from '@shared/components/noData'
import ScorecardSlider from '@shared/components/scorecardSlider'
import LazyLoad from '@shared/components/lazyLoad'
import { RightArrow } from '@shared/components/ctIcons'
// import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'

function SeriesHome({
  data: { oArticles = { aResults: [] }, oVideos = { aResults: [] }, fantasyArticle = { aResults: [] }, seriesDescription },
  playerData = [],
  category,
  onTabChanges,
  seriesHeaderData,
  scoreCard,
  seriesUrls,
  seriesId
}) {
  const [newArticle, setNewsArticle] = useState(oArticles?.aResults)
  const [showMore, setShowMore] = useState(false)
  // const { seriesData, loading } = useQuery(FETCH_TEAM_VENUE, { input: { iSeriesId: seriesId } })

  const [getRandomArticles] = useLazyQuery(GET_RANDOM_ARTICLE, {
    variables: { input: { nSample: 7 } },
    onCompleted: article => {
      article?.randomArticles && setNewsArticle(article?.randomArticles)
    }
  })

  const handleDesc = () => {
    setShowMore(!showMore)
  }

  function handleTabChange(tab) {
    const ele = document?.getElementById('client-common-nav')?.offsetTop
    window?.scrollTo({ top: ele, behavior: 'smooth' })
    onTabChanges && onTabChanges(tab)
  }

  useEffect(() => {
    if (category?.eType === 'p' || category?.eType === 'gt' || category?.eType === 't' || category?.eType === 'pct') {
      if (newArticle?.length === 0 && fantasyArticle?.aResults?.length === 0) getRandomArticles()
    }
  }, [category])

  useEffect(() => {
    setNewsArticle(oArticles?.aResults)
  }, [oArticles])

  const contentLength = category?.sContent?.length
  const trimmedContent = useMemo(
    () => (contentLength > 500 ? category?.sContent?.slice(0, 500) + '...' : category?.sContent),
    [category?.sContent]
  )

  return (
    <>
      <div className={styles.seriesHome}>
        {category?.sContent && (
          <div
            className={`${showMore && styles.active} big-text`}
            dangerouslySetInnerHTML={{ __html: showMore ? category?.sContent : trimmedContent }}></div>
        )}

        {category?.sContent && contentLength > 500 && (
          <div className={styles.readBtn}>
            <a className={styles.readMore} onClick={handleDesc}>
              {(showMore ? 'Read Less' : 'Read More')}
            </a>
          </div>
        )}

        {seriesDescription?.bIsCustomSeriesDescription && (
          <div>
            <h3 className='small-head mb-2'>
              Overview
            </h3>
            <div className={styles.desc}>{seriesDescription?.sCustomSeriesDescription}</div>
          </div>
        )}
        {scoreCard?.length > 0 && (
          <h6>
            Matches
          </h6>
        )}
        {category?.eType === 'as' && (
          <div className={styles.seriesScorecard}>
            <ScorecardSlider
              data={scoreCard}
              seriesId={category?.iSeriesId}
              customPrevArrow={styles.previousArrow}
              customNextArrow={styles.nextArrow}
            />
          </div>
        )}

        {playerData && playerData?.length !== 0 && (
          <section>
            <div className={'d-flex justify-content-between align-items-center'}>
              <h6>
                Key Stats
              </h6>
              {seriesUrls?.stats && (
                <CustomLink href={`/${seriesUrls?.stats}`} prefetch={false}>
                  <a className={`theme-btn nobg-btn border-0 ${styles.viewAllVideos}`}>
                    View All
                  </a>
                </CustomLink>
              )}
            </div>
            <div className={styles.p0}>
              <TopPlayerRankings data={playerData} />
            </div>
          </section>
        )}
        {newArticle?.length !== 0 && (
          <>
            {/* <h6>
              Latest Article
            </h6> */}
            {playerData && playerData?.length === 0 ? (
              <section>
                <Row>
                  {newArticle?.slice(0, 6)?.map((a, i) => {
                    return (
                      <React.Fragment key={i + a?._id}>
                        <Col lg={4} sm={6} id={a?._id}>
                          <ArticleGrid data={a} isVideo={a?.__typename === 'oVideoData'} showDuration />
                        </Col>
                      </React.Fragment>
                    )
                  })}
                </Row>
                {newArticle?.length >= 7 && (
                  <LazyLoad>
                    <div className="text-center theme-text">
                      {onTabChanges ? (
                        <Button onClick={() => handleTabChange('news')} className="theme-btn btn btn-primary">
                          More News
                          <RightArrow />
                        </Button>
                      ) : (
                        <CustomLink href={'/' + seriesUrls?.news} prefetch={false}>
                          <a className="theme-btn btn btn-primary">
                            More News
                            <RightArrow />
                          </a>
                        </CustomLink>
                      )}
                    </div>
                  </LazyLoad>
                )}
              </section>
            ) : (
              <LazyLoad>
                <section>
                  <Row>
                    {newArticle?.slice(0, 6).map((a, i) => {
                      if (i >= 0) {
                        return (
                          <React.Fragment key={i + a?._id}>
                            <Col lg={4} sm={6} id={a?._id}>
                              <ArticleGrid data={a} isVideo={a?.__typename === 'oVideoData'} />
                            </Col>
                          </React.Fragment>
                        )
                      } else return null
                    })}
                  </Row>
                  {newArticle?.length >= 7 && (
                    <div className="text-center theme-text">
                      {onTabChanges ? (
                        <Button className="theme-btn btn btn-primary" onClick={() => handleTabChange('news')}>
                          More
                          News
                          <RightArrow />
                        </Button>
                      ) : (
                        <CustomLink href={'/' + seriesUrls?.news} prefetch={false}>
                          <a className="theme-btn btn btn-primary">
                            More News
                            <RightArrow />
                          </a>
                        </CustomLink>
                      )}
                    </div>
                  )}
                </section>
              </LazyLoad>
            )}
          </>
        )}
        {/* {fantasyArticle?.aResults?.length > 0 && (
          <>
            <h4 className="text-uppercase">
              Fantasy Articles
            </h4>
            <section>
              <ArticleSmall isLarge={true} isVideo={fantasyArticle?.aResults[0]?.__typename === 'oVideoData'} data={fantasyArticle?.aResults[0]} />
              <Row>
                {fantasyArticle?.aResults?.map((a, i) => {
                  if (i > 0) {
                    return (
                      <Col lg={4} key={i + a?._id} sm={6} id={a?._id}>
                        <ArticleGrid data={a} isVideo={a?.__typename === 'oVideoData'} />
                      </Col>
                    )
                  } else return null
                })}
              </Row>
              {fantasyArticle?.aResults?.length >= 7 && (
                <div className="text-center theme-text">
                  {onTabChanges ? (
                    <Button className='theme-btn small-btn' onClick={() => handleTabChange('fantasyArticle')}>
                      More Fantasy Articles {'>'}
                    </Button>
                  ) : (
                    <CustomLink href={'/' + urls['fantasy-tips']} prefetch={false}>
                      <a className="theme-btn small-btn">
                        More Fantasy Articles {'>'}
                      </a>
                    </CustomLink>
                  )}
                </div>
              )}
            </section>
          </>
        )} */}
        {/* {
          oVideos?.aResults?.length > 0 && (
            <>
              <LazyLoad>
                <h3 className="small-head">
                  Videos
                </h3>
                <section>
                  <Row>
                    {
                      oVideos?.aResults?.slice(0, 6).map((a, i) => {
                        if (i >= 0) {
                          return (
                            <Col lg={4} key={i + a?._id} sm={6} id={a?._id}>
                              <ArticleGrid isVideoTab={true} data={a} isVideo={a?.__typename === 'oVideoData'} />
                            </Col>
                          )
                        } else return null
                      })
                    }
                  </Row>
                  {
                    oVideos?.aResults?.length >= 7 && (
                      <div className="text-center theme-text">
                        {onTabChanges ? (
                          <Button className='theme-btn btn btn-primary' onClick={() => handleTabChange('videos')}>
                            More Videos
                            <RightArrow />
                          </Button>
                        ) : (
                          <CustomLink href={'/' + seriesUrls?.videos} prefetch={false} >
                            <a className="theme-btn btn btn-primary">
                              More Videos
                              <RightArrow />
                            </a>
                          </CustomLink>
                        )}
                      </div>
                    )
                  }
                </section>
              </LazyLoad>
            </>
          )
        } */}
        {scoreCard?.length === 0 &&
          fantasyArticle?.aResults?.length === 0 &&
          oVideos?.aResults?.length === 0 &&
          newArticle?.length === 0 &&
          playerData?.length === 0 && <NoData />}
      </div>
    </>
  )
}

SeriesHome.defaultProps = {
  data: { oArticles: {}, oVideos: {}, fantasyArticle: {} }
}

SeriesHome.propTypes = {
  data: PropTypes.object,
  seriesHeaderData: PropTypes.object,
  playerData: PropTypes.array,
  category: PropTypes.object,
  scoreCard: PropTypes.array,
  onTabChanges: PropTypes.func,
  seriesUrls: PropTypes.object,
  seriesId: PropTypes.string
}

export default SeriesHome
